(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canvas-builder-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const builders = document.querySelectorAll('[data-canvas-builder]');
    const textureTargets = {
      'Suit SU01 Cream': 'cotton-canvas-model-03.jpg',
      'Suit SU02 Grey': 'cotton-canvas-model-06.jpg',
      'Suit SU03 Jut': 'cotton-canvas-model-09.jpg',
      'Suit SU04 Anthracite': 'cotton-canvas-model-01.jpg',
      'Suit SU05 Brown': 'cotton-canvas-model-02.jpg',
      'Judy JD01 Cream': 'cotton-canvas-model-04.jpg',
      'Judy JD02 Natural': 'cotton-canvas-model-07.jpg',
      'Judy JD03 Sand': 'cotton-canvas-model-10.jpg',
      'Look LK01 Cream': 'cotton-canvas-model-05.jpg',
      'Look LK02 Grey': 'cotton-canvas-model-08.jpg',
      'Look LK03 Jut': 'cotton-canvas-model-11.jpg',
    };

    function repairTextureImages(builder) {
      const sourcesByFile = {};

      builder.querySelectorAll('.canvas-builder-page__texture-image').forEach((image) => {
        const filename = image.currentSrc.match(/cotton-canvas-model-\d+\.jpg/)?.[0] || image.src.match(/cotton-canvas-model-\d+\.jpg/)?.[0];
        if (filename && !sourcesByFile[filename]) {
          sourcesByFile[filename] = image.currentSrc || image.src;
        }
      });

      builder.querySelectorAll('[data-option-group="model"]').forEach((button) => {
        const targetFile = textureTargets[button.dataset.optionLabel];
        const image = button.querySelector('.canvas-builder-page__texture-image');

        if (targetFile && image && sourcesByFile[targetFile]) {
          image.src = sourcesByFile[targetFile];
        }
      });
    }

    builders.forEach((builder) => {
      if (builder.dataset.canvasBuilderReady === 'true') return;
      builder.dataset.canvasBuilderReady = 'true';
      repairTextureImages(builder);

      const state = {
        shape: '',
        model: '',
        bordure: '',
        size: '',
        customWidth: '',
        customLength: '',
        note: '',
      };

      const summary = {
        shape: builder.querySelector('[data-summary-shape]'),
        model: builder.querySelector('[data-summary-model]'),
        bordure: builder.querySelector('[data-summary-bordure]'),
        size: builder.querySelector('[data-summary-size]'),
      };
      const customSize = builder.querySelector('[data-custom-size]');
      const customWidth = builder.querySelector('[data-custom-width]');
      const customLength = builder.querySelector('[data-custom-length]');
      const note = builder.querySelector('[data-canvas-note]');
      const whatsappLink = builder.querySelector('[data-whatsapp-link]');
      const status = builder.querySelector('[data-canvas-status]');
      const phoneNumber = (builder.dataset.whatsappNumber || '').replace(/\D/g, '');

      function getSizeLabel() {
        if (state.size !== 'Özel ölçü') return state.size;
        if (!state.customWidth || !state.customLength) return 'Özel ölçü';
        return `Özel ölçü: ${state.customWidth}x${state.customLength} cm`;
      }

      function isComplete() {
        if (!state.shape || !state.model || !state.bordure || !state.size) return false;
        if (state.size === 'Özel ölçü') {
          return Boolean(state.customWidth && state.customLength);
        }
        return true;
      }

      function buildMessage() {
        return [
          'Merhaba, Canvas halı için teklif almak istiyorum.',
          '',
          `Şekil: ${state.shape}`,
          `Model: ${state.model}`,
          `Biye: ${state.bordure}`,
          `Ölçü: ${getSizeLabel()}`,
          state.note ? `Not: ${state.note}` : '',
        ].filter(Boolean).join('\n');
      }

      function updateSummary() {
        summary.shape.textContent = state.shape || 'Seçilmedi';
        summary.model.textContent = state.model || 'Seçilmedi';
        summary.bordure.textContent = state.bordure || 'Seçilmedi';
        summary.size.textContent = getSizeLabel() || 'Seçilmedi';

        if (!isComplete()) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'Tüm seçimleri tamamlayınca WhatsApp mesajı hazırlanır.';
          return;
        }

        if (phoneNumber.length < 10) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'WhatsApp numarası section ayarlarına ülke koduyla eklenmeli.';
          return;
        }

        whatsappLink.classList.remove('is-disabled');
        whatsappLink.removeAttribute('aria-disabled');
        whatsappLink.setAttribute('href', `https://wa.me/${phoneNumber}?text=${encodeURIComponent(buildMessage())}`);
        status.textContent = 'WhatsApp mesajı hazır. Butona basınca seçimleriniz otomatik aktarılır.';
      }

      function selectOption(group, label) {
        const buttons = Array.from(builder.querySelectorAll(`[data-option-group="${group}"]`));
        const selectedButton = buttons.find((button) => button.dataset.optionLabel === label);

        buttons.forEach((button) => {
          button.classList.toggle('is-selected', button === selectedButton);
          button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
        });

        state[group] = label;

        if (group === 'size') {
          const isCustom = label === 'Özel ölçü';
          customSize.hidden = !isCustom;
          if (!isCustom) {
            state.customWidth = '';
            state.customLength = '';
            customWidth.value = '';
            customLength.value = '';
          }
        }

        updateSummary();
      }

      builder.addEventListener('click', (event) => {
        const option = event.target.closest('[data-option-group]');

        if (option && builder.contains(option)) {
          selectOption(option.dataset.optionGroup, option.dataset.optionLabel);
          return;
        }

        const combination = event.target.closest('[data-combination]');

        if (combination && builder.contains(combination)) {
          builder.querySelectorAll('[data-combination]').forEach((button) => {
            button.classList.toggle('is-selected', button === combination);
          });
          selectOption('shape', combination.dataset.shape);
          selectOption('model', combination.dataset.model);
          selectOption('bordure', combination.dataset.bordure);
          builder.querySelector('.canvas-builder-page__builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      customWidth.addEventListener('change', () => {
        state.customWidth = customWidth.value;
        updateSummary();
      });

      customLength.addEventListener('input', () => {
        state.customLength = customLength.value;
        updateSummary();
      });

      note.addEventListener('input', () => {
        state.note = note.value.trim();
        updateSummary();
      });

      updateSummary();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canvas-builder-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const builders = document.querySelectorAll('[data-canvas-builder]');
    const textureTargets = {
      'Suit SU01 Cream': 'cotton-canvas-model-03.jpg',
      'Suit SU02 Grey': 'cotton-canvas-model-06.jpg',
      'Suit SU03 Jut': 'cotton-canvas-model-09.jpg',
      'Suit SU04 Anthracite': 'cotton-canvas-model-01.jpg',
      'Suit SU05 Brown': 'cotton-canvas-model-02.jpg',
      'Judy JD01 Cream': 'cotton-canvas-model-04.jpg',
      'Judy JD02 Natural': 'cotton-canvas-model-07.jpg',
      'Judy JD03 Sand': 'cotton-canvas-model-10.jpg',
      'Look LK01 Cream': 'cotton-canvas-model-05.jpg',
      'Look LK02 Grey': 'cotton-canvas-model-08.jpg',
      'Look LK03 Jut': 'cotton-canvas-model-11.jpg',
    };

    function repairTextureImages(builder) {
      const sourcesByFile = {};

      builder.querySelectorAll('.canvas-builder-page__texture-image').forEach((image) => {
        const filename = image.currentSrc.match(/cotton-canvas-model-\d+\.jpg/)?.[0] || image.src.match(/cotton-canvas-model-\d+\.jpg/)?.[0];
        if (filename && !sourcesByFile[filename]) {
          sourcesByFile[filename] = image.currentSrc || image.src;
        }
      });

      builder.querySelectorAll('[data-option-group="model"]').forEach((button) => {
        const targetFile = textureTargets[button.dataset.optionLabel];
        const image = button.querySelector('.canvas-builder-page__texture-image');

        if (targetFile && image && sourcesByFile[targetFile]) {
          image.src = sourcesByFile[targetFile];
        }
      });
    }

    builders.forEach((builder) => {
      if (builder.dataset.canvasBuilderReady === 'true') return;
      builder.dataset.canvasBuilderReady = 'true';
      repairTextureImages(builder);

      const state = {
        shape: '',
        model: '',
        bordure: '',
        size: '',
        customWidth: '',
        customLength: '',
        note: '',
      };

      const summary = {
        shape: builder.querySelector('[data-summary-shape]'),
        model: builder.querySelector('[data-summary-model]'),
        bordure: builder.querySelector('[data-summary-bordure]'),
        size: builder.querySelector('[data-summary-size]'),
      };
      const customSize = builder.querySelector('[data-custom-size]');
      const customWidth = builder.querySelector('[data-custom-width]');
      const customLength = builder.querySelector('[data-custom-length]');
      const note = builder.querySelector('[data-canvas-note]');
      const whatsappLink = builder.querySelector('[data-whatsapp-link]');
      const status = builder.querySelector('[data-canvas-status]');
      const phoneNumber = (builder.dataset.whatsappNumber || '').replace(/\D/g, '');

      function getSizeLabel() {
        if (state.size !== 'Özel ölçü') return state.size;
        if (!state.customWidth || !state.customLength) return 'Özel ölçü';
        return `Özel ölçü: ${state.customWidth}x${state.customLength} cm`;
      }

      function isComplete() {
        if (!state.shape || !state.model || !state.bordure || !state.size) return false;
        if (state.size === 'Özel ölçü') {
          return Boolean(state.customWidth && state.customLength);
        }
        return true;
      }

      function buildMessage() {
        return [
          'Merhaba, Canvas halı için teklif almak istiyorum.',
          '',
          `Şekil: ${state.shape}`,
          `Model: ${state.model}`,
          `Biye: ${state.bordure}`,
          `Ölçü: ${getSizeLabel()}`,
          state.note ? `Not: ${state.note}` : '',
        ].filter(Boolean).join('\n');
      }

      function updateSummary() {
        summary.shape.textContent = state.shape || 'Seçilmedi';
        summary.model.textContent = state.model || 'Seçilmedi';
        summary.bordure.textContent = state.bordure || 'Seçilmedi';
        summary.size.textContent = getSizeLabel() || 'Seçilmedi';

        if (!isComplete()) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'Tüm seçimleri tamamlayınca WhatsApp mesajı hazırlanır.';
          return;
        }

        if (phoneNumber.length < 10) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'WhatsApp numarası section ayarlarına ülke koduyla eklenmeli.';
          return;
        }

        whatsappLink.classList.remove('is-disabled');
        whatsappLink.removeAttribute('aria-disabled');
        whatsappLink.setAttribute('href', `https://wa.me/${phoneNumber}?text=${encodeURIComponent(buildMessage())}`);
        status.textContent = 'WhatsApp mesajı hazır. Butona basınca seçimleriniz otomatik aktarılır.';
      }

      function selectOption(group, label) {
        const buttons = Array.from(builder.querySelectorAll(`[data-option-group="${group}"]`));
        const selectedButton = buttons.find((button) => button.dataset.optionLabel === label);

        buttons.forEach((button) => {
          button.classList.toggle('is-selected', button === selectedButton);
          button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
        });

        state[group] = label;

        if (group === 'size') {
          const isCustom = label === 'Özel ölçü';
          customSize.hidden = !isCustom;
          if (!isCustom) {
            state.customWidth = '';
            state.customLength = '';
            customWidth.value = '';
            customLength.value = '';
          }
        }

        updateSummary();
      }

      builder.addEventListener('click', (event) => {
        const option = event.target.closest('[data-option-group]');

        if (option && builder.contains(option)) {
          selectOption(option.dataset.optionGroup, option.dataset.optionLabel);
          return;
        }

        const combination = event.target.closest('[data-combination]');

        if (combination && builder.contains(combination)) {
          builder.querySelectorAll('[data-combination]').forEach((button) => {
            button.classList.toggle('is-selected', button === combination);
          });
          selectOption('shape', combination.dataset.shape);
          selectOption('model', combination.dataset.model);
          selectOption('bordure', combination.dataset.bordure);
          builder.querySelector('.canvas-builder-page__builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      customWidth.addEventListener('change', () => {
        state.customWidth = customWidth.value;
        updateSummary();
      });

      customLength.addEventListener('input', () => {
        state.customLength = customLength.value;
        updateSummary();
      });

      note.addEventListener('input', () => {
        state.note = note.value.trim();
        updateSummary();
      });

      updateSummary();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suit-biye-builder-page-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const builders = document.querySelectorAll('[data-suit-biye-builder]');

    builders.forEach((builder) => {
      if (builder.dataset.suitBiyeBuilderReady === 'true') return;
      builder.dataset.suitBiyeBuilderReady = 'true';

      const state = {
        model: '',
        bordure: '',
        size: '',
        customWidth: '',
        customLength: '',
        note: '',
      };

      const summary = {
        model: builder.querySelector('[data-summary-model]'),
        bordure: builder.querySelector('[data-summary-bordure]'),
        size: builder.querySelector('[data-summary-size]'),
      };
      const customSize = builder.querySelector('[data-custom-size]');
      const customWidth = builder.querySelector('[data-custom-width]');
      const customLength = builder.querySelector('[data-custom-length]');
      const note = builder.querySelector('[data-suit-biye-note]');
      const whatsappLink = builder.querySelector('[data-whatsapp-link]');
      const status = builder.querySelector('[data-suit-biye-status]');
      const phoneNumber = (builder.dataset.whatsappNumber || '').replace(/\D/g, '');

      function getSizeLabel() {
        if (state.size !== 'Özel ölçü') return state.size;
        if (!state.customWidth || !state.customLength) return 'Özel ölçü';
        return `Özel ölçü: ${state.customWidth}x${state.customLength} cm`;
      }

      function isComplete() {
        if (!state.model || !state.bordure || !state.size) return false;
        if (state.size === 'Özel ölçü') return Boolean(state.customWidth && state.customLength);
        return true;
      }

      function buildMessage() {
        return [
          'Merhaba, Suit Biye halı için teklif almak istiyorum.',
          '',
          `Doku: ${state.model}`,
          `Biye: ${state.bordure}`,
          `Ölçü: ${getSizeLabel()}`,
          state.note ? `Not: ${state.note}` : '',
        ].filter(Boolean).join('\n');
      }

      function updateSummary() {
        summary.model.textContent = state.model || 'Seçilmedi';
        summary.bordure.textContent = state.bordure || 'Seçilmedi';
        summary.size.textContent = getSizeLabel() || 'Seçilmedi';

        if (!isComplete()) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'Tüm seçimleri tamamlayınca WhatsApp mesajı hazırlanır.';
          return;
        }

        if (phoneNumber.length < 10) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'WhatsApp numarası section ayarlarına ülke koduyla eklenmeli.';
          return;
        }

        whatsappLink.classList.remove('is-disabled');
        whatsappLink.removeAttribute('aria-disabled');
        whatsappLink.setAttribute('href', `https://wa.me/${phoneNumber}?text=${encodeURIComponent(buildMessage())}`);
        status.textContent = 'WhatsApp mesajı hazır. Butona basınca seçimleriniz otomatik aktarılır.';
      }

      function selectOption(group, label) {
        const buttons = Array.from(builder.querySelectorAll(`[data-option-group="${group}"]`));
        const selectedButton = buttons.find((button) => button.dataset.optionLabel === label);

        buttons.forEach((button) => {
          button.classList.toggle('is-selected', button === selectedButton);
          button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
        });

        state[group] = label;

        if (group === 'size') {
          const isCustom = label === 'Özel ölçü';
          customSize.hidden = !isCustom;
          if (!isCustom) {
            state.customWidth = '';
            state.customLength = '';
            customWidth.value = '';
            customLength.value = '';
          }
        }

        updateSummary();
      }

      builder.addEventListener('click', (event) => {
        const option = event.target.closest('[data-option-group]');

        if (option && builder.contains(option)) {
          selectOption(option.dataset.optionGroup, option.dataset.optionLabel);
          return;
        }

        const combination = event.target.closest('[data-combination]');

        if (combination && builder.contains(combination)) {
          builder.querySelectorAll('[data-combination]').forEach((button) => {
            button.classList.toggle('is-selected', button === combination);
          });
          selectOption('model', combination.dataset.model);
          selectOption('bordure', combination.dataset.bordure);
          builder.querySelector('.suit-biye-builder-page__builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      customWidth.addEventListener('change', () => {
        state.customWidth = customWidth.value;
        updateSummary();
      });

      customLength.addEventListener('input', () => {
        state.customLength = customLength.value;
        updateSummary();
      });

      note.addEventListener('input', () => {
        state.note = note.value.trim();
        updateSummary();
      });

      updateSummary();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suit-biye-builder-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const builders = document.querySelectorAll('[data-suit-biye-builder]');

    builders.forEach((builder) => {
      if (builder.dataset.suitBiyeBuilderReady === 'true') return;
      builder.dataset.suitBiyeBuilderReady = 'true';

      const state = {
        model: '',
        bordure: '',
        size: '',
        customWidth: '',
        customLength: '',
        note: '',
      };

      const summary = {
        model: builder.querySelector('[data-summary-model]'),
        bordure: builder.querySelector('[data-summary-bordure]'),
        size: builder.querySelector('[data-summary-size]'),
      };
      const customSize = builder.querySelector('[data-custom-size]');
      const customWidth = builder.querySelector('[data-custom-width]');
      const customLength = builder.querySelector('[data-custom-length]');
      const note = builder.querySelector('[data-suit-biye-note]');
      const whatsappLink = builder.querySelector('[data-whatsapp-link]');
      const status = builder.querySelector('[data-suit-biye-status]');
      const phoneNumber = (builder.dataset.whatsappNumber || '').replace(/\D/g, '');

      function getSizeLabel() {
        if (state.size !== 'Özel ölçü') return state.size;
        if (!state.customWidth || !state.customLength) return 'Özel ölçü';
        return `Özel ölçü: ${state.customWidth}x${state.customLength} cm`;
      }

      function isComplete() {
        if (!state.model || !state.bordure || !state.size) return false;
        if (state.size === 'Özel ölçü') return Boolean(state.customWidth && state.customLength);
        return true;
      }

      function buildMessage() {
        return [
          'Merhaba, Suit Biye halı için teklif almak istiyorum.',
          '',
          `Doku: ${state.model}`,
          `Biye: ${state.bordure}`,
          `Ölçü: ${getSizeLabel()}`,
          state.note ? `Not: ${state.note}` : '',
        ].filter(Boolean).join('\n');
      }

      function updateSummary() {
        summary.model.textContent = state.model || 'Seçilmedi';
        summary.bordure.textContent = state.bordure || 'Seçilmedi';
        summary.size.textContent = getSizeLabel() || 'Seçilmedi';

        if (!isComplete()) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'Tüm seçimleri tamamlayınca WhatsApp mesajı hazırlanır.';
          return;
        }

        if (phoneNumber.length < 10) {
          whatsappLink.classList.add('is-disabled');
          whatsappLink.setAttribute('aria-disabled', 'true');
          whatsappLink.setAttribute('href', '#');
          status.textContent = 'WhatsApp numarası section ayarlarına ülke koduyla eklenmeli.';
          return;
        }

        whatsappLink.classList.remove('is-disabled');
        whatsappLink.removeAttribute('aria-disabled');
        whatsappLink.setAttribute('href', `https://wa.me/${phoneNumber}?text=${encodeURIComponent(buildMessage())}`);
        status.textContent = 'WhatsApp mesajı hazır. Butona basınca seçimleriniz otomatik aktarılır.';
      }

      function selectOption(group, label) {
        const buttons = Array.from(builder.querySelectorAll(`[data-option-group="${group}"]`));
        const selectedButton = buttons.find((button) => button.dataset.optionLabel === label);

        buttons.forEach((button) => {
          button.classList.toggle('is-selected', button === selectedButton);
          button.setAttribute('aria-pressed', button === selectedButton ? 'true' : 'false');
        });

        state[group] = label;

        if (group === 'size') {
          const isCustom = label === 'Özel ölçü';
          customSize.hidden = !isCustom;
          if (!isCustom) {
            state.customWidth = '';
            state.customLength = '';
            customWidth.value = '';
            customLength.value = '';
          }
        }

        updateSummary();
      }

      builder.addEventListener('click', (event) => {
        const option = event.target.closest('[data-option-group]');

        if (option && builder.contains(option)) {
          selectOption(option.dataset.optionGroup, option.dataset.optionLabel);
          return;
        }

        const combination = event.target.closest('[data-combination]');

        if (combination && builder.contains(combination)) {
          builder.querySelectorAll('[data-combination]').forEach((button) => {
            button.classList.toggle('is-selected', button === combination);
          });
          selectOption('model', combination.dataset.model);
          selectOption('bordure', combination.dataset.bordure);
          builder.querySelector('.suit-biye-builder-page__builder')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      customWidth.addEventListener('change', () => {
        state.customWidth = customWidth.value;
        updateSummary();
      });

      customLength.addEventListener('input', () => {
        state.customLength = customLength.value;
        updateSummary();
      });

      note.addEventListener('input', () => {
        state.note = note.value.trim();
        updateSummary();
      });

      updateSummary();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
